import React, { useEffect, useState } from 'react'

// react meta tags
import { ReactTitle } from "react-meta-tags";

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { BsEyeSlash, BsEye } from "react-icons/bs";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from "react-toastify";

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,

    CUSTOMER_UPDATED_SUCCESSFULLY,
    ERROR_WHILE_UPDATING_CUSTOMER
} from "utlis/AppMessages/AppMessages";
import { updateCustomersPassword } from 'utlis/Apis/Customers_API';

function ChangePassword(props) {
    // props
    const {
        currentUser,
        commonToken
    } = props

    // states
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false)

    const [showOldPassword, setShowOldPassword] = useState(false)
    const [showNewPassword, setShowNewPassword] = useState(false)

    // initial form values
    const initialFormValues = {
        oldPassword: '',
        newPassword: '',
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        // oldPassword: Yup.string()
        //     .required('This field is required')
        //     .min(8, "The password must be at least 8 characters long")
        //     .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, "Pasword must contain at least one uppercase letter, one lowercase letter, one number and one special character"),
        newPassword: Yup.string()
            .required('This field is required')
            .min(8, "The password must be at least 8 characters long")
        // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, "Pasword must contain at least one uppercase letter, one lowercase letter, one number and one special character"),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // button loading
            setBtnLoading(true)
            setBtnDisabled(true)

            const customerInfo = {
                user_id: currentUser.userId,
                newPassword: values.newPassword
            }

            // network request
            updateCustomersPassword(commonToken, customerInfo).then(res => {
                // button loading
                setBtnLoading(false)
                setBtnDisabled(false)

                const resData = res.data

                // if request is success
                if (resData?.success) {
                    formik.resetForm() // resetting the form

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(CUSTOMER_UPDATED_SUCCESSFULLY, {
                        autoClose: 2000
                    });
                }

                // if request is error
                if (resData?.error) {

                    const errorMessage = UNKNOWN_ERROR_OCCURED

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(errorMessage, {
                        autoClose: 2000
                    });
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} updateCustomer `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // button loading
                        setBtnLoading(false)
                        setBtnDisabled(false)
                    },
                });
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // toggle old password
    const toggleOldPasswordDisplay = ev => {
        ev.preventDefault()
        setShowOldPassword(!showOldPassword)
    }

    // toggle new password
    const toggleNewPasswordDisplay = ev => {
        ev.preventDefault()
        setShowNewPassword(!showNewPassword)
    }

    return (
        <React.Fragment>
            {/* website title */}
            <ReactTitle title={"Change Password | Ruhlistic Decor"} />

            <div className="header-sec">
                <p className="head text-capitalize st-fw-800 mb-2">Update Password</p>
                <p className="desc">
                    Update your password details.
                </p>
            </div>

            <form
                onSubmit={formik.handleSubmit}
                noValidate
                autoComplete="off">
                {/* input field */}
                {/* <div className={`form-item position-relative mb-3 ${(formik.touched.oldPassword && formik.errors.oldPassword) ? "has-error" : ""}`}>
                    <label className="mb-2 st-fw-800">Old Password <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                    <input
                        type="password"
                        className="default-form-input form-control rounded-0"
                        {...formik.getFieldProps('oldPassword')}
                    />

                    <div className="icon position-absolute">
                        <div className="cursor-pointer" onClick={toggleOldPasswordDisplay}>
                            {
                                showOldPassword ? <BsEyeSlash /> : <BsEye />
                            }
                        </div>
                    </div>

                    {
                        (formik.touched.oldPassword && formik.errors.oldPassword) ? (
                            <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                {formik.errors.oldPassword}
                            </div>
                        ) : null
                    }
                </div> */}

                {/* input field */}
                <div className={`form-item position-relative mb-3 ${(formik.touched.newPassword && formik.errors.newPassword) ? "has-error" : ""}`}>
                    <label className="mb-2 st-fw-800">New Password <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                    <input
                        type={showNewPassword ? "text" : "password"}
                        className="default-form-input form-control rounded-0"
                        {...formik.getFieldProps('newPassword')}
                    />

                    {/* icon */}
                    <div className="icon position-absolute">
                        <div className="cursor-pointer" onClick={toggleNewPasswordDisplay}>
                            {
                                showNewPassword ? <BsEyeSlash /> : <BsEye />
                            }
                        </div>
                    </div>

                    {
                        (formik.touched.newPassword && formik.errors.newPassword) ? (
                            <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                {formik.errors.newPassword}
                            </div>
                        ) : null
                    }
                </div>

                <div className="btns pt-1">
                    <button
                        type="submit"
                        className="btn rounded-0 btn-block text-uppercase st-fw-800 default-btn"
                        disabled={btnDisabled}>
                        {
                            btnLoading ? (
                                <Spinner animation="border" size="sm" />
                            ) : (
                                <span>Apply changes</span>
                            )
                        }
                    </button>
                </div>
            </form>
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        currentUser: state.auth.currentUser,
        commonToken: state.auth.commonToken,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//     };
// };

export default connect(getDataFromStore, null)(ChangePassword);